import type { ComponentProps } from 'react';
import React from 'react';

import { cn } from '@change/ds-utils';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import type { PaypalState } from 'src/app/shared/hooks/payments';
import { usePaypal } from 'src/app/shared/hooks/payments';

import type { PaypalButtonSDK } from '../PaypalButtonSDK';

type Props = {
	style?: ComponentProps<typeof PaypalButtonSDK>['style'];
};

const ColorStyles = {
	// TODO: implement real styles for this color if needed
	black: {
		bg: 'black',
		borderColor: 'black',
	},
	blue: {
		bg: '#0070ba',
		borderColor: '#0070ba',
	},
	// TODO: implement real styles for this color if needed
	gold: {
		bg: 'black',
		borderColor: 'black',
	},
	// TODO: implement real styles for this color if needed
	silver: {
		bg: 'black',
		borderColor: 'black',
	},
	white: {
		bg: 'white',
		borderColor: 'black',
	},
};

export const PaypalButtonLoading: React.FC<Props> = ({ style = { color: 'white' } }) => {
	const paypalState: PaypalState = usePaypal();
	return (
		<div
			className={cn({ hidden: paypalState.status === 'error' })}
			data-testid="paypal-button-loading"
			style={{
				backgroundColor: ColorStyles[style.color || 'white'].bg,
				height: style.height || 45,
				width: '100%',
				borderColor: ColorStyles[style.color || 'white'].borderColor,
				borderRadius: style.borderRadius || 8,
			}}
		>
			<div className="flex h-full w-full items-center justify-center">
				<Loader size="xs" color="highlight" />
			</div>
		</div>
	);
};
